<template>
  <section class="px-[15px] py-[60px] md:py-[100px]">
    <div class="md:container">
      <div
        class="px-1 pt-4 pb-5 md:p-6 lg:p-[30px] xl:p-10 rounded-md bg-dark-gray-100 text-black"
      >
        <h1
          class="px-4 mt-0 py-0 text-lg leading-6 md:text-[26px] md:leading-[36px] font-bold font-ff-good-pro-cond"
        >
          {{ $t("common.warranty_page.annex") }} <br />
          <span class="font-normal">{{ $t("common.warranty_page.list") }}</span>
        </h1>

        <!-- Criteria -->
        <table
          class="bg-white rounded-lg md:rounded-[10px] mt-[30px] w-full table-fixed border-collapse tracking-[0.4px]"
        >
          <thead>
            <th
              class="border-b border-r border-[#EDEEF1] pt-4 pb-[10px] px-4 md:pt-5 md:pb-4 md:pl-[30px]"
              colspan="2"
            >
              <span
                v-text="$t('common.warranty_page.criteria')"
                class="flex justify-start font-bold text-sm leading-[18px] md:text-xl md:leading-6 text-left capitalize tracking-[0.4px] font-ff-good-pro-cond"
              ></span>
            </th>
            <th
              class="border-b border-[#EDEEF1] pt-4 pb-[10px] md:pt-[30px] md:pb-4"
            >
              <span
                v-text="$t('common.warranty_page.total_weight_limit')"
                class="flex justify-center font-bold text-sm leading-[18px] md:text-xl md:leading-6 text-center capitalize tracking-[0.4px] font-ff-good-pro-cond"
              ></span>
            </th>
          </thead>
          <tbody
            class="text-sm leading-[22px] font-normal md:text-base md:leading-7 tracking-[0.4px] font-ff-good-pro-cond"
          >
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.fork')"></p>
              </td>
              <td rowspan="5" class="p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  120 {{ $t("common.warranty_page.kg") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.rim')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.without_handlebar')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.without_seat_post')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.without_saddle')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.bike_fork')"></p>
              </td>
              <td rowspan="5" class="p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  90 {{ $t("common.warranty_page.kg") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.fiber_rim')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.handlebar')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.seat_post')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.saddle')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.al_frame')"></p>
              </td>
              <td rowspan="2" class="p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  90 {{ $t("common.warranty_page.kg") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.frame')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.16')"></p>
              </td>
              <td class="p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  60 {{ $t("common.warranty_page.kg") }}
                </p>
              </td>
            </tr>
            <tr class="border-t border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.12')"></p>
              </td>
              <td class="p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  45 {{ $t("common.warranty_page.kg") }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Characteristic -->
        <table
          class="bg-white rounded-[10px] mt-4 md:mt-[10px] w-full table-fixed border-collapse leading-[0.4px]"
        >
          <thead>
            <th
              class="border-b border-r border-[#EDEEF1] pt-4 pb-[10px] pl-4 md:pt-5 md:pb-4 md:pl-[30px]"
              colspan="2"
            >
              <span
                v-text="$t('common.warranty_page.characteristic')"
                class="flex justify-start font-bold text-left capitalize text-sm leading-[18px] md:text-xl md:leading-6 tracking-[0.4px] font-ff-good-pro-cond"
              ></span>
            </th>
            <th
              class="border-b border-[#EDEEF1] pt-4 pb-[10px] md:pt-[30px] md:pb-4"
            >
              <span
                v-text="$t('common.warranty_page.load_weight')"
                class="flex justify-center font-bold text-center capitalize text-sm leading-[18px] md:text-xl md:leading-6 tracking-[0.4px] font-ff-good-pro-cond"
              ></span>
            </th>
          </thead>
          <tbody
            class="font-normal text-sm leading-[22px] md:text-base md:leading-7 tracking-[0.4px] font-ff-good-pro-cond"
          >
            <tr class="border-y border-[#EDEEF1]">
              <td
                rowspan="2"
                colspan="2"
                class="pl-4 py-[10px] md:px-[30px] md:py-4"
              >
                <p v-text="$t('common.warranty_page.rack_anchor')"></p>
              </td>
              <td class="p-[10px] md:p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  {{ $t("common.warranty_page.rear_rack") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td
                class="px-4 py-3 text-center border-l md:px-10 md:py-4 border-[#EDEEF1]"
              >
                <p v-text="$t('common.warranty_page.seat_post_bag')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td
                rowspan="2"
                colspan="2"
                class="pl-4 py-[10px] md:px-[30px] md:py-4"
              >
                <p v-text="$t('common.warranty_page.no_rack_mount')"></p>
              </td>
              <td class="p-[10px] md:p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  {{ $t("common.warranty_page.rear_rack_clamps") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td
                class="px-4 py-3 text-center border-l md:px-10 md:py-4 border-[#EDEEF1]"
              >
                <p v-text="$t('common.warranty_page.seat_post_bag')"></p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.any_20_24_bike')"></p>
              </td>
              <td class="p-[10px] md:p-4 border-l border-[#EDEEF1]">
                <p class="text-center">
                  {{ $t("common.warranty_page.seat_post_bag") }}
                </p>
              </td>
            </tr>
            <tr class="border-y border-[#EDEEF1]">
              <td colspan="2" class="pl-4 py-[10px] md:px-[30px] md:py-4">
                <p v-text="$t('common.warranty_page.any_12_14_bike')"></p>
              </td>
              <td class="p-[10px] md:p-4 border-l border-[#EDEEF1]">
                <p class="text-center">0 {{ $t("common.warranty_page.kg") }}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="text-base lg:text-lg lg:leading-7 mx-auto md:px-0 px-3 max-w-[638px] font-ff-good-pro-cond font-normal tracking-[0.4px] mt-4 md:mt-6 text-center"
        >
          <span class="font-bold">
            {{ $t("common.warranty_page.total_weight_limit") }} :
          </span>
          &nbsp;{{ $t("common.warranty_page.total_max_loads") }}
        </div>
        <div
          class="flex items-center justify-center mt-10 md:mt-[30px] w-full md:px-0 px-3"
        >
          <Btn
            type="button"
            size="xl"
            block
            :rounded="false"
            class="rounded-md md:w-[173px] w-full"
            color="primary"
            @click="openWarrantyModal"
          >
            <span
              class="text-lg font-bold leading-6 text-center text-white uppercase"
            >
              {{ $t("common.warranty_request") }}
            </span>
          </Btn>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useModal } from "vue-final-modal";
import WarrantyModal from "~/modals/WarrantyRequestForm.vue";

function openWarrantyModal() {
  console.log("Opening modal...");
  const { open, close } = useModal({
    component: WarrantyModal,
    attrs: {
      isChangeDir: true,
    },
  });
  open();
}
</script>
